import { z } from 'zod';
export const UserTypeRouteBase = z.union([
    z.literal('client'),
    z.literal('independent'),
]);
export const OnboardingSources = z.enum([
    'post-new-job',
    'leave-recommendation',
    'join-teammate',
    'get-in-touch',
    'join-network',
    'direct-payment',
    'apply-to-expert-network',
    'discover-advanced-filters',
    'project-proposal',
    'invoice-payment',
    'community-waitlist',
    'social-referral',
]);
export const ClientWorkspacePlanNid = z.union([
    z.literal('BUILD'),
    z.literal('GROW'),
    z.literal('SCALE'),
    z.literal('MEMBERS_ONLY'),
]);
export const IndependentDiscoverabilityFactorEducationDrawer = z.union([
    z.literal('ProfileQuality'),
    z.literal('ProfileCompletion'),
    z.literal('AverageRating'),
    z.literal('Availability'),
    z.literal('ContraPro'),
    z.literal('InquiryResponseTime'),
    z.literal('Earnings'),
    z.literal('NumberOfReviews'),
    z.literal('ExpertBadges'),
    z.literal('ProjectQuality'),
    z.literal('ServiceQuality'),
    z.literal('CommunityRepliesReceived'),
    z.literal('CommunityReactionsReceived'),
    z.literal('CommunityFeedContributions'),
]);
//# sourceMappingURL=schemas.js.map